'use client';

import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion } from 'motion/react';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import { BlurImage } from '@/components/blur-image';
import { cn } from '@/utils/cn';
const WORDS = [{
  // i18n-check t('homepage.hero.amazing')
  key: 'amazing',
  className: 'from-[#ff1835] to-[#ffc900]'
}, {
  // i18n-check t('homepage.hero.stunning')
  key: 'stunning',
  className: 'from-[#0077ff] to-[#00e7df]'
}, {
  // i18n-check t('homepage.hero.fantastic')
  key: 'fantastic',
  className: 'from-[#7f00de] to-[#ff007f]'
}, {
  // i18n-check t('homepage.hero.attractive')
  key: 'attractive',
  className: 'from-[#2ecc70] to-[#1ca085]'
}] as const;
export function Hero() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="my-16 flex justify-between"><Introduction /><Avatar /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function Introduction() {
  const $ = _c(58);
  const [index, setIndex] = useState(0);
  const t = useTranslations();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const interval = setInterval(() => {
        setIndex(_temp);
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const WORD = WORDS[index % WORDS.length] ?? WORDS[0];
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      x: -20,
      opacity: 0
    };
    t3 = {
      x: 0,
      opacity: 1
    };
    t4 = {
      ease: "easeOut"
    };
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t("homepage.hero.line-1");
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <motion.div initial={t2} animate={t3} transition={t4}>{t5}</motion.div>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  let t8;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      x: -30,
      opacity: 0
    };
    t8 = {
      x: 0,
      opacity: 1
    };
    t9 = {
      ease: "easeOut"
    };
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t7 = $[9];
    t8 = $[10];
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t) {
    t10 = t("homepage.hero.line-2-left");
    $[12] = t;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10) {
    t11 = <motion.span layout={true}>{t10}</motion.span>;
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  let t13;
  let t14;
  let t15;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      y: 100,
      opacity: 0
    };
    t13 = {
      y: 0,
      opacity: 1
    };
    t14 = {
      y: -100,
      opacity: 0
    };
    t15 = {
      type: "tween",
      duration: 0.3
    };
    $[16] = t12;
    $[17] = t13;
    $[18] = t14;
    $[19] = t15;
  } else {
    t12 = $[16];
    t13 = $[17];
    t14 = $[18];
    t15 = $[19];
  }
  let t16;
  if ($[20] !== WORD.className) {
    t16 = cn("mx-1.75 inline-block bg-linear-to-r bg-clip-text text-transparent", WORD.className);
    $[20] = WORD.className;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  const t17 = `homepage.hero.${WORD.key}`;
  let t18;
  if ($[22] !== t || $[23] !== t17) {
    t18 = t(t17);
    $[22] = t;
    $[23] = t17;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== index || $[26] !== t16 || $[27] !== t18) {
    t19 = <motion.div layout={true} className="relative inline-block overflow-hidden align-bottom"><AnimatePresence mode="popLayout" initial={false}><motion.span key={index} initial={t12} animate={t13} exit={t14} transition={t15} layout={true} className={t16}>{t18}</motion.span></AnimatePresence></motion.div>;
    $[25] = index;
    $[26] = t16;
    $[27] = t18;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== t) {
    t20 = t("homepage.hero.line-2-right");
    $[29] = t;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== t20) {
    t21 = <motion.span layout={true} className="inline-block">{t20}</motion.span>;
    $[31] = t20;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  let t22;
  if ($[33] !== t11 || $[34] !== t19 || $[35] !== t21) {
    t22 = <motion.div initial={t7} animate={t8} transition={t9}>{t11}{t19}{t21}</motion.div>;
    $[33] = t11;
    $[34] = t19;
    $[35] = t21;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  let t24;
  let t25;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = {
      x: -40,
      opacity: 0
    };
    t24 = {
      x: 0,
      opacity: 1
    };
    t25 = {
      ease: "easeOut"
    };
    $[37] = t23;
    $[38] = t24;
    $[39] = t25;
  } else {
    t23 = $[37];
    t24 = $[38];
    t25 = $[39];
  }
  let t26;
  if ($[40] !== t) {
    t26 = t("homepage.hero.line-3");
    $[40] = t;
    $[41] = t26;
  } else {
    t26 = $[41];
  }
  let t27;
  if ($[42] !== t26) {
    t27 = <motion.div initial={t23} animate={t24} transition={t25}>{t26}</motion.div>;
    $[42] = t26;
    $[43] = t27;
  } else {
    t27 = $[43];
  }
  let t28;
  if ($[44] !== t22 || $[45] !== t27 || $[46] !== t6) {
    t28 = <h1 className="space-y-2 text-xl font-semibold sm:text-3xl">{t6}{t22}{t27}</h1>;
    $[44] = t22;
    $[45] = t27;
    $[46] = t6;
    $[47] = t28;
  } else {
    t28 = $[47];
  }
  let t29;
  let t30;
  let t31;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = {
      x: -50,
      opacity: 0
    };
    t30 = {
      x: 0,
      opacity: 1
    };
    t31 = {
      ease: "easeOut"
    };
    $[48] = t29;
    $[49] = t30;
    $[50] = t31;
  } else {
    t29 = $[48];
    t30 = $[49];
    t31 = $[50];
  }
  let t32;
  if ($[51] !== t) {
    t32 = t("homepage.hero.location-timezone");
    $[51] = t;
    $[52] = t32;
  } else {
    t32 = $[52];
  }
  let t33;
  if ($[53] !== t32) {
    t33 = <motion.div initial={t29} animate={t30} transition={t31} className="text-sm text-muted-foreground">{t32}</motion.div>;
    $[53] = t32;
    $[54] = t33;
  } else {
    t33 = $[54];
  }
  let t34;
  if ($[55] !== t28 || $[56] !== t33) {
    t34 = <div className="space-y-4">{t28}{t33}</div>;
    $[55] = t28;
    $[56] = t33;
    $[57] = t34;
  } else {
    t34 = $[57];
  }
  return t34;
}
function _temp(prev) {
  return (prev + 1) % WORDS.length;
}
function Avatar() {
  const $ = _c(10);
  const t = useTranslations();
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      scale: 0
    };
    t1 = {
      scale: 1
    };
    t2 = {
      duration: 0.3
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("homepage.hero.image-alt");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <BlurImage src="/images/avatar.png" className="size-28 rounded-full" width={1024} height={1024} alt={t3} lazy={false} />;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="absolute inset-0 -z-10 bg-linear-to-tl from-purple-700 to-orange-700 opacity-50 blur-2xl" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <motion.div className="relative hidden size-28 md:block" initial={t0} animate={t1} transition={t2}>{t4}{t5}</motion.div>;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}